export default __webpack_public_path__ + "static/media/postIcon.3c86f32f.svg";